import React from 'react';
import Head from 'next/head';
import NoopLayout from '@website/components/layouts/NoopLayout';
import SocialLoginCallback from '@website/components/auth/SocialLoginCallback';

/**
 * Callback page for social login
 */
export default function AuthCallback() {
  return (
    <>
      <Head>
        <title>Logging you in</title>
      </Head>
      <SocialLoginCallback />
    </>
  );
}

AuthCallback.Layout = NoopLayout;
